import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalS,
  },

  input: {
    width: '100%',
  },

  dropdown: {
    width: '100%',
  },

  textarea: {
    width: '100%',
  },

  helperText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase200,
  },

  errorBar: {
    marginTop: tokens.spacingVerticalXS,
  },
});
